import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  DownlinesCard,
  DownlinesContainer,
  DownlinesTopCard,
  DownlinesTopCardButton,
} from "./Downlines.styled";
import { useDispatch, useSelector } from "react-redux";
import { getUserInvites } from "../../feature/referral/ReferralActions";
import Avatar, { genConfig } from "react-nice-avatar";
import { inviteErnings } from "../../feature/invite/InviteActions";

const Downlines = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.user);
  const { invites } = useSelector((state) => state.referral);
  const { earning } = useSelector((state) => state.invite);

  useEffect(() => {
    Object.keys(user).length &&
      dispatch(getUserInvites({ referral_code: user.referral_code }));
    Object.keys(user).length && dispatch(inviteErnings({ user: user.id }));
  }, [dispatch, user]);

  return (
    <DownlinesContainer>
      <DownlinesTopCard>
        <DownlinesTopCardButton onClick={() => navigate("/about-downlines")}>
          About Downlines
        </DownlinesTopCardButton>
        <DownlinesTopCardButton onClick={() => navigate("/invite")}>
          Invite Now
        </DownlinesTopCardButton>
      </DownlinesTopCard>
      <DownlinesCard
        style={{ border: "1px solid #9965f2", borderRadius: "10px" }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            padding: "10px",
          }}
        >
          <h3 style={{ lineHeight: 0 }}>Total Invites:</h3>
          <h3 style={{ lineHeight: 0 }}>{invites.length}</h3>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            padding: "10px",
          }}
        >
          <h3 style={{ lineHeight: 0 }}>Has Purchased Miner:</h3>
          <h3 style={{ lineHeight: 0 }}>
            {invites && invites.filter((invite) => invite.has_machine).length}
          </h3>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            padding: "10px",
          }}
        >
          <h3 style={{ lineHeight: 0 }}>Earnings from invites (TRX):</h3>
          <h3 style={{ lineHeight: 0 }}>{earning && earning.amount_earned}</h3>
        </div>
      </DownlinesCard>
      <DownlinesCard
        style={{
          border: "1px solid rgba(223, 232, 115, 0.2)",
          padding: "20px",
          marginBlock: "40px 30px",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            backgroundColor: "#7B36EE",
            color: "#fff",
            fontWeight: "bolder",
            fontSize: "20px",
            height: "30px",
            width: "60%",
            marginBlock: "-40px 10px",
            marginInline: "auto",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          First Downlines
        </div>
        {invites.map((data, index, row) => (
          <div
            style={{
              // background: "#592498",
              border: "1px solid #7B36EE",
              padding: "10px",
              display: "flex",
              alignItems: "center",
              marginBlockEnd: "10px",
            }}
            key={index}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <div>
                <Avatar
                  style={{
                    height: 30,
                    width: 30,
                    objectFit: "cover",
                    borderRadius: "50%",
                    marginInline: "15px",
                  }}
                  isGradient={true}
                  {...genConfig(`${data.username}`)}
                />
              </div>
              <div>{data.username}</div>
            </div>
            <div
              style={{
                display: `${data.has_machine ? "flex" : "none"}`,
                justifyContent: "center",
                marginInlineStart: "auto",
                backgroundColor: "#7B36EE",
                color: "#fff",
                width: "30%",
                paddingBlock: "8px",
              }}
            >
              Active
            </div>
          </div>
        ))}
      </DownlinesCard>
    </DownlinesContainer>
  );
};

export default Downlines;
